"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _forwardRefWithStatics = require("../_utils/forwardRefWithStatics");
var _ListItem = _interopRequireDefault(require("./ListItem"));
var _ListGroup = _interopRequireDefault(require("./ListGroup"));
var _Empty = _interopRequireDefault(require("./Empty"));
var _excluded = ["children", "className", "style", "type"];
var List = (0, _forwardRefWithStatics.forwardRefWithStatics)(function Lists(_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    type = _ref.type,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('list');
  var classes = (0, _classnames2.default)(prefixCls, className, (0, _defineProperty2.default)({}, "".concat(prefixCls, "--").concat(type), !!type));
  var Parent = type === 'number' ? 'ol' : 'ul';
  return /*#__PURE__*/_react.default.createElement(Parent, (0, _extends2.default)({
    className: classes,
    style: style,
    ref: ref
  }, props), children);
}, {
  Item: _ListItem.default,
  Group: _ListGroup.default,
  Empty: _Empty.default
});

// 组件的默认值
List.defaultProps = {
  className: ''
};
var _default = exports.default = List;